import { Checkbox } from "@mui/material";
import ListSubheader from "@mui/material/ListSubheader";
import { RowComponentProps } from "react-window";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

import { VirtualAutocompleteItem } from "./types";
import { LISTBOX_PADDING } from "./constants";

type Props = RowComponentProps<{ itemData: VirtualAutocompleteItem[] }>;

// This component renders a single row in the virtualized listbox for the
// VirtualizedAutocomplete component. It handles both group headers and
// selectable options, which are represented by the union type VirtualAutocompleteItem.
export function AutocompleteRow({ index, itemData, style }: Props) {
  const item = itemData[index];
  const inlineStyle = {
    ...style,
    top: ((style.top as number) ?? 0) + LISTBOX_PADDING,
  };

  if ("group" in item) {
    // This item is a group. Just render the header.
    return (
      <ListSubheader key={item.key} component="div" style={inlineStyle}>
        {item.group}
      </ListSubheader>
    );
  }

  // This item is not a group; it's a selectable option.
  const { props, label, labelSuffix, selected } = item;
  const { key, ...optionProps } = props;

  return (
    <li
      key={key}
      {...optionProps}
      style={{
        ...inlineStyle,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <Checkbox
          size="small"
          icon={<CheckBoxOutlineBlank />}
          checkedIcon={<CheckBox />}
          style={{ marginLeft: -8 }}
          checked={selected}
        />
        <span>{label}</span>
      </div>
      <span>{labelSuffix}</span>
    </li>
  );
}
